function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AssignmentsService from '@/apps/data-platform/services/tables_views/assignments_service';
import { textsDefaul, TYPE_CHANGE_METADA, envConfig } from '@/js/constants';
import tasks from '@/js/tasks';
import utils from '@/js/utils';
import FormChangeMetaDataDatasource from '@/components/tableau/FormChangeMetaDataDatasource';
import FormChangeMetaDataWorkbook from '@/components/tableau/FormChangeMetaDataWorkbook';
import FormTemporalAssignment from '@/components/tableau/FormTemporalAssignment';
import FormTableTemporalAssignment from '@/components/FormTableTemporalAssignment';
import DialogsComponent from '@/components/DialogsComponent.vue';
import FormAccessRequestTableComponent from '@/apps/data-platform/components/FormAccessRequestTableComponent.vue';
import FormMetadataChangeResponse from '@/components/FormMetadataChangeResponse.vue';
import FormAccessRequest from '@/components/FormAccessRequest.vue';
import OrganizacionComponent from '@/components/OrganizacionComponent.vue';
import { status } from 'nprogress';
export default {
  name: 'ContMyActivity',
  components: {
    DialogsComponent: DialogsComponent,
    FormChangeMetaDataDatasource: FormChangeMetaDataDatasource,
    FormChangeMetaDataWorkbook: FormChangeMetaDataWorkbook,
    FormTemporalAssignment: FormTemporalAssignment,
    FormTableTemporalAssignment: FormTableTemporalAssignment,
    FormAccessRequestTableComponent: FormAccessRequestTableComponent,
    FormMetadataChangeResponse: FormMetadataChangeResponse,
    FormAccessRequest: FormAccessRequest,
    OrganizacionComponent: OrganizacionComponent
  },
  data: function data() {
    return {
      isStartDateChanged: false,
      isEndDateChanged: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      types: ['CHANGE_METADATA', 'ACCESS', 'APPROVE_OWNER'],
      statuses: ['APPROVED', 'REJECTED', 'REVISION', 'PROCESSING'],
      formattedStartDate: "",
      formattedEndDate: "",
      filteredResults: [],
      isAdmin: window.userInfo.userRoles.includes("org_datamgmt_lead"),
      domain: window.userInfo.domain,
      MODAL_NAME_LOGS: 'ContMyActivityOwner',
      MODAL_NAME_DATASOURCE: 'ContChangeMetadataDatasource',
      MODAL_NAME_WORKBOOK: 'ContChangeMetadataWorkbook',
      MODAL_NAME_TABLEAU_TEMPORAL_OPERATOR: 'ContTableauTemporalOperator',
      MODAL_NAME_TABLE_TEMPORAL_OPERATOR: 'ContTableTemporalOperator',
      historyPageToken: '',
      itemDetail: null,
      messageLoading: textsDefaul.LOADING,
      cancelRequestLoading: false,
      messageEmptyList: textsDefaul.NOT_REQUEST,
      isBusy: false,
      toFilter: {},
      queryResponse: [],
      filter: '',
      filterOn: [],
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      objToRequest: {},
      PAGE_TAGS_SIZE: envConfig.pagintaionTagsSize,
      titleModal: '',
      temporalAssignmentRecord: Object,
      filter_enabled: false,
      // true,
      serverItems: [],
      // datos actuales
      currentCursor: null,
      // cursor actual (before)
      nextCursor: null,
      // cursor que devuelve backend
      pagination: {
        current: 1,
        limit: envConfig.pagintaionSize,
        cursors: [null],
        // lista de cursores previos
        next: false,
        total: 0
      },
      key_pagination: 1,
      loadingPage: false
    };
  },
  computed: {
    tableFields: function tableFields() {
      return [{
        text: this.traductor('requests.tablas.source'),
        value: 'source',
        class: 'text-left'
      }, {
        text: this.traductor('requests.tablas.object'),
        value: 'table_id',
        sortable: true,
        class: 'text-left'
      }, {
        text: this.traductor('requests.tablas.type'),
        value: 'type',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('requests.tablas.creation_date'),
        value: 'created_datetime',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('requests.tablas.status'),
        value: 'status',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('requests.tablas.responsible'),
        value: 'operator',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('requests.tablas.applicant'),
        value: 'applicant',
        sortable: true,
        align: 'center'
      }, {
        value: 'respDate',
        text: this.traductor('requests.tablas.response_date'),
        sortable: true,
        align: 'center'
      }, {
        value: 'endDate',
        text: this.traductor('requests.tablas.end_date'),
        align: 'center'
      }, {
        value: 'actions',
        text: this.traductor('requests.tablas.actions'),
        align: 'center'
      }];
    },
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.traductor('requests.subtitle_requests'),
        disabled: true
      }];
    },
    getClassTable: function getClassTable() {
      if (this.filter_enabled) return 'col-md-9 col-sm-12';else return 'col-sm-12';
    }
  },
  created: function created() {
    var lastWeek = new Date();
    lastWeek.setDate(lastWeek.getDate() - 30);
    this.toFilter = {
      email: window.userInfo.email,
      startDate: utils.getToDayString(lastWeek),
      endDate: utils.getToDayString(),
      optionMetadata: true,
      optionAccessRequired: true,
      optionAccessResponse: true
    };
    this.formattedStartDate = this.formatDate(this.toFilter.startDate);
    this.formattedEndDate = this.formatDate(this.toFilter.endDate);
    this.fetchPage(true);
  },
  methods: {
    changePage: function changePage(page) {
      this.pagination.current = page;
      this.fetchPage();
    },
    fetchPage: function () {
      var _fetchPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var reset,
          index,
          cursor,
          params,
          response,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              reset = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              this.loadingPage = true;
              if (reset) {
                this.pagination.current = 1;
                this.pagination.cursors = [null];
                this.key_pagination++;
              }
              index = this.pagination.current - 1;
              cursor = this.pagination.cursors[index];
              params = {
                email: this.toFilter.email,
                init_date: utils.dateBrowserToService(this.toFilter.startDate),
                end_date: utils.dateBrowserToService(this.toFilter.endDate),
                limit: this.pagination.limit,
                cursor: cursor,
                type: this.toFilter.type || null,
                status: this.toFilter.status || null,
                organization: this.toFilter.organization || null,
                applicant: this.toFilter.applicant || null,
                isAdmin: this.isAdmin
              };
              _context.p = 1;
              _context.n = 2;
              return AssignmentsService.getRequestsByDate(params);
            case 2:
              response = _context.v;
              this.serverItems = response.data.items || [];
              this.nextCursor = response.data.nextCursor || null;
              this.pagination.total = response.data.total || 0;
              if (this.nextCursor && !this.pagination.cursors[this.pagination.current]) {
                this.pagination.cursors.push(this.nextCursor);
              }
            case 3:
              _context.p = 3;
              this.loadingPage = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function fetchPage() {
        return _fetchPage.apply(this, arguments);
      }
      return fetchPage;
    }(),
    onDownload: function onDownload() {
      var columns = ['source', 'table_id', 'type', 'created_datetime', 'status', 'operator', 'applicant', 'respDate', 'endDate', 'actions'];
      var body = [columns.join(';')];
      var x, y;
      var row1 = [];
      for (x = 0; x < this.filteredResults.length; x++) {
        row1.push({
          source: this.filteredResults[x].source,
          table_id: this.filteredResults[x].table_id,
          type: this.filteredResults[x].type,
          created_datetime: this.filteredResults[x].created_datetime,
          status: this.filteredResults[x].status,
          operator: this.filteredResults[x].operator,
          applicant: this.filteredResults[x].applicant,
          respDate: this.filteredResults[x].respDate,
          endDate: this.filteredResults[x].endDate,
          actions: this.filteredResults[x].actions
        });
      }
      var row = [];
      for (var _i = 0, _row = row1; _i < _row.length; _i++) {
        var record = _row[_i];
        var _iterator = _createForOfIteratorHelper(columns),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var column = _step.value;
            row.push(record[column]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        row = row.join(';');
        body.push(row);
        row = [];
      }
      var data = body.join('\n');
      var fileName = 'Solicitudes.csv';
      tasks.saveData(data, fileName);
    },
    formatDate: function formatDate(date) {
      if (!date) return null;
      var _date$split = date.split('-'),
        _date$split2 = _slicedToArray(_date$split, 3),
        year = _date$split2[0],
        month = _date$split2[1],
        day = _date$split2[2];
      return "".concat(day, "/").concat(month, "/").concat(year);
    },
    onStartDateChange: function onStartDateChange(date) {
      this.toFilter.startDate = date;
      this.toFilter.type = '';
      this.toFilter.status = '';
      this.toFilter.organization = '';
      this.toFilter.applicant = '';
      this.formattedStartDate = this.formatDate(date);
      this.menu = false;
      this.isStartDateChanged = true;
    },
    onEndDateChange: function onEndDateChange(date) {
      this.toFilter.endDate = date;
      this.toFilter.type = '';
      this.toFilter.status = '';
      this.toFilter.organization = '';
      this.toFilter.applicant = '';
      this.formattedEndDate = this.formatDate(date);
      this.menu = false;
      this.isEndDateChanged = true;
    },
    parseDate: function parseDate(date) {
      if (!date) return '';
      var parsedDate = parse(date, 'dd/MM/yyyy', new Date());
      return format(parsedDate, 'yyyy-MM-dd');
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    onLimpiar: function onLimpiar() {
      var lastWeek = new Date();
      lastWeek.setDate(lastWeek.getDate() - 30);
      this.toFilter = {
        email: window.userInfo.email,
        startDate: utils.getToDayString(lastWeek),
        endDate: utils.getToDayString(),
        type: '',
        status: '',
        organization: '',
        applicant: '',
        optionMetadata: true,
        optionAccessRequired: true,
        optionAccessResponse: true
      };
      this.formattedStartDate = this.formatDate(this.toFilter.startDate);
      this.formattedEndDate = this.formatDate(this.toFilter.endDate);
      this.fetchPage(true);
    },
    // agregando un parámetro modalName
    showItemDetails: function showItemDetails(item) {
      var _this = this;
      // clone
      this.itemDetail = utils.cloneJSON(item);
      // agregado de metadata
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: this.itemDetail.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: this.itemDetail.index_node,
        domain_table: this.itemDetail.domain_table,
        check_original: this.itemDetail.type == 'CHANGE_METADATA' ? true : false,
        source: this.itemDetail.source ? this.itemDetail.source : "bigquery"
      };
      AssignmentsService.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          _this.objToRequest = response.data;
          _this.objToRequest.item = _this.itemDetail;
          _this.objToRequest.tableInfo = _this.itemDetail; // propiedad para log en formmetadata
          _this.objToRequest.tipo = 'vista'; // sugerencia de agregado para la zona de botones
          // tipo será vacío no sin antes de hacer click y llamar al método, es por ello que en la llamada de botones
          // a no ser que sea en formMetaData en List ObjectSearch linea 242
          // this.$bvModal.show(modalName)
          // Posible eliminación
          var separeValues = tasks.filterDefaultTableTagsAndColumnFields(_this.itemDetail.fields);
          _this.itemDetail.defaultFields = utils.objectToArray(separeValues.defaultFields);
          _this.itemDetail.columnFields = utils.objectToArray(separeValues.columnFields);
          _this.$refs[_this.MODAL_NAME_LOGS].onOpen();
          return true;
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    cancelRequest: function () {
      var _cancelRequest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(item) {
        var data, regex, matches, values, body, response, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              console.log(item);
              this.cancelRequestLoading = true;
              data = {};
              if (item.isIndented && item.isIndented[0]) {
                regex = /:\s*([^,]+)/g;
                matches = _toConsumableArray(collection_name.matchAll(regex));
                values = matches.map(function (match) {
                  return match[1].trim();
                });
                data = _defineProperty(_defineProperty({
                  id_firestore: item.id,
                  is_indented: item.isIndented[0],
                  firstCollection: values[0],
                  document: values[1],
                  secondCollection: values[2]
                }, "id_firestore", item.id), "domain", item.domain_table);
              } else {
                data = {
                  id_firestore: item.id,
                  is_indented: item.isIndented[0],
                  domain: item.domain_table
                };
              }
              body = {
                data: data,
                status: 'CANCELED'
              };
              _context2.p = 1;
              _context2.n = 2;
              return AssignmentsService.setStatus(body);
            case 2:
              response = _context2.v;
              if (response.code === 200) {
                tasks.toast.success(response.data.columns.response, this.translate('titles.success'));
              } else {
                tasks.toast.error(this.translate('error_messages.error_general'), this.translate('titles.error'));
              }
              this.getActivities();
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              utils.printError(_t);
              tasks.toast.error(this.translate('error_messages.error_general'), this.translate('titles.error'));
            case 4:
              _context2.p = 4;
              this.cancelRequestLoading = false;
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3, 4, 5]]);
      }));
      function cancelRequest(_x) {
        return _cancelRequest.apply(this, arguments);
      }
      return cancelRequest;
    }(),
    sendToFilter: function sendToFilter(q) {
      this.filter = q;
    },
    getActivitiesFront: function getActivitiesFront(event) {
      if (event) event.preventDefault();

      // resetear flags de fechas
      this.isStartDateChanged = false;
      this.isEndDateChanged = false;

      // 🔥 volver a consultar desde el inicio
      this.fetchPage(true);
    },
    getActivities: function getActivities(event) {
      var _this2 = this;
      if (event) event.preventDefault();
      this.isBusy = true;
      var fiterToSend = utils.cloneJSON(this.toFilter);
      console.log('fiterToSend', fiterToSend);
      var email = fiterToSend.email;
      var initDate = utils.dateBrowserToService(fiterToSend.startDate);
      var endDate = utils.dateBrowserToService(fiterToSend.endDate);
      var organization = fiterToSend.organization;
      var type = fiterToSend.type;
      var status = fiterToSend.status;
      var applicant = fiterToSend.applicant;
      var isAdmin = this.isAdmin;
      console.log('isAdmin', this.isAdmin);
      var metadata = fiterToSend.optionMetadata;
      var accessRequired = fiterToSend.optionAccessRequired;
      var accessResponse = fiterToSend.optionAccessResponse;
      console.log(window.userInfo.domain);
      if (!metadata && !accessRequired && !accessResponse) {
        metadata = true;
        accessRequired = true;
        accessResponse = true;
      }
      var params = {
        email: email,
        init_date: initDate,
        end_date: endDate,
        isAdmin: isAdmin,
        metadata: metadata,
        access_required: accessRequired,
        access_response: accessResponse
      };
      if (this.domain !== 'intercorp.com.pe' && isAdmin) {
        params.organization = this.domain;
      }
      AssignmentsService.getRequestsByDate(params).then(function (response) {
        if (response.data && response.data.length) {
          response.data.forEach(function (objeto) {
            if (!objeto.hasOwnProperty('source')) {
              objeto.source = 'bigquery';
            }
          });
          _this2.queryResponse = response.data || {};
          var auxiliar = [];
          for (var i = 0; i < _this2.queryResponse.length; i++) {
            //if (this.queryResponse[i].type !== 'APPROVE_OWNER')
            auxiliar.push(_this2.queryResponse[i]);
          }
          _this2.queryResponse = auxiliar;
          if (!auxiliar.length) {
            _this2.messageEmptyList = textsDefaul.NOT_REQUEST;
          }
        } else {
          _this2.queryResponse = response.data || {};
          _this2.messageEmptyList = textsDefaul.NOT_REQUEST;
        }
        _this2.filteredResults = _this2.queryResponse;
        if (_this2.queryResponse.length === 0) {
          _this2.types = ['CHANGE_METADATA', 'ACCESS', 'APPROVE_OWNER'];
          _this2.statuses = ['PENDING', 'APPROVED', 'REJECTED'];
        } else {
          _this2.types = _toConsumableArray(new Set(_this2.queryResponse.map(function (item) {
            return item.type;
          })));
          _this2.statuses = _toConsumableArray(new Set(_this2.queryResponse.map(function (item) {
            return item.status;
          }).filter(function (status) {
            return status !== null && status !== undefined;
          })));
        }
      }).catch(function (e) {
        utils.printError(e);
        // this.getActivities()
      }).finally(function () {
        if (_this2.isStartDateChanged || _this2.isEndDateChanged) {
          var filterToSend = utils.cloneJSON(_this2.toFilter);
          var _params = {};
          if (filterToSend.type) _params.type = filterToSend.type;
          if (filterToSend.status) _params.status = filterToSend.status;
          if (filterToSend.organization) _params.domain_table = filterToSend.organization;
          if (filterToSend.applicant) _params.applicant = filterToSend.applicant;
          _this2.filteredResults = _this2.queryResponse.filter(function (item) {
            return Object.entries(_params).every(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];
              return item[key] && item[key].toString().toLowerCase() === value.toString().toLowerCase();
            });
          });
          _this2.isStartDateChanged = false;
          _this2.isEndDateChanged = false;
        }
        _this2.isBusy = false;
        var identidados = _this2.queryResponse.filter(function (item) {
          return item.collection_name !== 'approval_flow';
        });
        console.log("identidados", identidados);
      });
    },
    onTableauOwnerDs: function onTableauOwnerDs(item) {
      this.itemDetail = item;
      this.titleModal = "".concat(item.object_type.toUpperCase(), " : ").concat(item.objectReference.path_name, "/").concat(item.objectReference.object_name);
      if (item.object_type === 'datasource') {
        this.$bvModal.show(this.MODAL_NAME_DATASOURCE);
      } else {
        this.$bvModal.show(this.MODAL_NAME_WORKBOOK);
      }
    },
    onClickTemporalDataOperator: function onClickTemporalDataOperator(item) {
      this.temporalAssignmentRecord = item.record;
      if (item.source === 'tableau') {
        this.$bvModal.show(this.MODAL_NAME_TABLEAU_TEMPORAL_OPERATOR);
      } else {
        this.$bvModal.show(this.MODAL_NAME_TABLE_TEMPORAL_OPERATOR);
      }
    }
  }
};